import React, { useState } from 'react';
import { compose, branch, renderNothing, withProps } from 'recompose';
import { withTranslations } from 'js/components/hocs/withTranslations';
import { statuses } from '../../constants';
import LeavePopup from './LeavePopup';
import { LeaveButton } from './LeaveButton';
import { leave } from '../../actions';

export const hideLeaveButton = ({ joined, status }) =>
    status === statuses.COMPLETED || status === statuses.PENDING_REVIEW || status === statuses.CANCELLED || !joined;

export const LeaveRace = (data) => {
    const { isLeavePopupOpen, toggleLeavePopup, missions, leaderboardId, t, wide, eventCountLimit, useTournament,
        trackLeaveEventClick } = data;

    const success = () => {
        console.log('successful leave');
    };

    const executeLeave = () => {
        leave({ leaderboardId }).then(success);
    };

    return (
        <>
            <LeaveButton onClick={missions ? executeLeave : toggleLeavePopup} t={t} wide={wide}
                         useTournament={useTournament} missions={missions}/>
            {!missions && isLeavePopupOpen && (
                <LeavePopup {...{ toggleLeavePopup, leaderboardId, t, eventCountLimit, useTournament, trackLeaveEventClick }} />
            )}
        </>
    );
};

export const withToggleLeavePopup = withProps(
    () => {
        const [isLeavePopupOpen, setIsLeavePopupOpen] = useState(false);
        const toggleLeavePopup = () => setIsLeavePopupOpen(!isLeavePopupOpen);

        return { isLeavePopupOpen, toggleLeavePopup };
    }
);

export default compose(
    branch(
        hideLeaveButton,
        renderNothing
    ),
    withTranslations,
    withToggleLeavePopup
)(LeaveRace);

